export default __webpack_public_path__ + "c884f82df841aeabcacc7b988a967542.webp";